import { makeStyles } from '@material-ui/core/styles';

export const useMessageMetaDataStyles = makeStyles(theme => ({
  metaDataContainer: {
    backgroundColor: theme.palette.common.white,
    borderRadius: theme.spacing(1),
    border: ({ isActive }) =>
      isActive ? `1px solid ${theme.palette.primary.main}` : '1px solid transparent',
    marginTop: theme.spacing(1),
    padding: theme.spacing(1),
    transition: 'all 0.2s ease',
    boxShadow: ({ isActive }) => (isActive ? '0 2px 8px rgba(0,0,0,0.12)' : 'none'),
    '&:hover': {
      boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
      cursor: 'pointer'
    }
  }
}));
